module.exports = __webpack_public_path__ + "img/blocks.ea26cc9c.png";